<div id="background-img-login"></div>

<div class="card login-zone-size">
	<article class="card-body">
		<!-- <a
			profile="button"
			href="https://www.isycare-technology.com"
			target="_blank"
			rel="noopener noreferrer"
		> -->
			<h3 class="card-title text-center mb-4 mt-4">
				<img
					id="logo-isycare"
					style="max-width:100em; height: auto;"
					src="assets/img/ocashe.png"
					alt="logo Isycare Technology abbrégé en Isy"
				/>
				<!-- <p class="unselectable-text">
					Bienvenue sur <strong>Ocashe</strong>
				</p> -->
			</h3>
		<!-- </a> -->
		<form>
			<div class="row">
				<div class="input-group mb-3">
					<span class="input-group-text theme-main-color">
						<i class="bi bi-person-fill fs-4" aria-hidden="true"></i>
					</span>
					<input
						type="text"
						class="form-control"
						name="login"
						placeholder="Votre adresse mail"
						[(ngModel)]="username"
						required
					/>
				</div>
			</div>

			<div class="row">
				<div class="input-group">
					<span class="input-group-text theme-main-color">
						<i class="bi-key-fill fs-4" aria-hidden="true"></i>
					</span>
					<input
						type="password"
						class="form-control"
						name="password"
						placeholder="Votre mot de passe"
						[(ngModel)]="password"
						passwordToggle
						required
					/>
				</div>
			</div>

			<div class="row d-flex flex-row-reverse mt-5">
				<button
					type="submit"
					class="btn theme-main-color-button fs-5"
					(click)="signIn()"
					[disabled]="
						username === '' || password === '' || isTryingToLogin
							? 'disabled'
							: null
					"
				>
					Se connecter
				</button>
			</div>

			<div *ngFor="let alert of alerts">
				<alert
					[type]="alert.type"
					[dismissible]="true"
					(onClosed)="onClosed(alert)"
					>{{ alert.msg }}</alert
				>
			</div>
			<p class="text-center mt-5 mb-1">
				<a routerLink="/recovery">Mot de passe oublié ?</a>
			</p>
		</form>
	</article>
</div>
